import { Globe, Menu, ShoppingCart, User2 } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { Badge, Button, Container, Dropdown, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from "../../assets/ownfood.png";
import { DashBoardLink } from "../../Helper/config";
import ShowLocation from "../Common/ShowLocation/ShowLocation";
import SideBar from "../Common/SideBar/SideBar";
import DrawerRight from "../Header/DrawerRight";
import SearchBar from "../Header/SearchBar/SearchBar";
import { clearSession, getStoredUser } from "../../services/auth.api";
import "./MobileHeader.css";

const MobileHeader = ({
  paneLeft,
  SetpanLeft,
  cart = [],
  state,
  setState,
  userAddress,
  setUserAddress,
}) => {
  const [user, setUser] = useState(null);

  const [selectedLang, setSelectedLang] = useState("bn");
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleSelect = (lang) => {
    setSelectedLang(lang);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // 👤 Handle user login state
  useEffect(() => {
    const checkUser = () => setUser(getStoredUser());

    checkUser();
    window.addEventListener("storage", checkUser);
    return () => window.removeEventListener("storage", checkUser);
  }, []);

  const handleLogout = () => {
    clearSession();
    window.location.reload(false);
  };

  return (
    <>
      <SideBar SetpanLeft={SetpanLeft} paneLeft={paneLeft} />
      <DrawerRight cart={cart} state={state} setState={setState} />

      <div className="mobile-header-container shadow-sm sticky top-0">
        <ShowLocation
          setUserAddress={setUserAddress}
          userAddress={userAddress}
        />

        <Navbar bg="white" className="mobile-header">
          <Container className="justify-content-between align-items-center">
            {/* Left: menu + logo */}
            <div className="d-flex align-items-center gap-2 flex-shrink-0">
              <div
                onClick={(e) => {
                  e.preventDefault();
                  SetpanLeft(true);
                }}
                className="mobile-menu-btn"
              >
                <Menu size={24} />
              </div>
              <div>
                <Link to={"/"}>
                  <img src={logo} alt="logo" className="horizontal-logo" />
                </Link>
              </div>
            </div>

            <div className="d-flex align-items-center gap-2 mobile-top-actions">
              <div className="dropdown d-none d-sm-block" ref={dropdownRef}>
                <button
                  className="btn btn-light dropdown-toggle d-flex align-items-center gap-1 language-switch-btn"
                  type="button"
                  onClick={toggleDropdown}
                >
                  <Globe size={15} /> <span>{selectedLang.toUpperCase()}</span>
                </button>

                <ul
                  className={`dropdown-menu ${isOpen ? "show" : ""}`}
                  style={{ minWidth: "auto" }}
                >
                  <li>
                    <button
                      className="dropdown-item d-flex align-items-center gap-2"
                      onClick={() => handleSelect("bn")}
                    >
                      <img
                        style={{ width: "20px" }}
                        src="/Assets/Img/countryflag/bangladesh.png"
                        alt="Bangla"
                      />
                      BN
                    </button>
                  </li>
                  <li>
                    <button
                      className="dropdown-item d-flex align-items-center gap-2"
                      onClick={() => handleSelect("en")}
                    >
                      <img
                        style={{ width: "20px" }}
                        src="/Assets/Img/countryflag/united-states.png"
                        alt="English"
                      />
                      EN
                    </button>
                  </li>
                </ul>
              </div>

              {user ? (
                <Dropdown align="end">
                  <Dropdown.Toggle
                    variant="light"
                    id="dropdown-basic"
                    className="p-0 border-0"
                    style={{
                      height: "38px",
                      width: "38px",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={
                        user?.userProfilePhoto?.length > 0
                          ? user?.userProfilePhoto[0]?.extraLarge?.imageUrl
                          : "https://static.vecteezy.com/system/resources/thumbnails/002/002/403/small/man-with-beard-avatar-character-isolated-icon-free-vector.jpg"
                      }
                      alt="User Profile"
                      className="rounded-circle"
                      style={{
                        width: "38px",
                        height: "38px",
                        objectFit: "cover",
                      }}
                    />
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item href="/profile">
                      Hi,{" "}
                      <span className="size-14 fw-semibold">
                        {user?.name?.split(" ")[0]}
                      </span>
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item href={DashBoardLink}>
                      Dashboard
                    </Dropdown.Item>
                    <Dropdown.Item href="/notifications">
                      Notification
                    </Dropdown.Item>
                    <Dropdown.Item href="/my-wishes">My Wishes</Dropdown.Item>
                    <Dropdown.Item href="/my-orders">My Orders</Dropdown.Item>
                    <Dropdown.Item href="/contact-us">Contact Support</Dropdown.Item>
                    <Dropdown.Item
                      onClick={handleLogout}
                      className="text-danger"
                    >
                      Logout
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              ) : (
                <Button
                  variant="light"
                  className="d-flex align-items-center gap-1 mobile-login-btn"
                >
                  <User2 size={16} />
                  <span className="login-text">
                    <Link to={"/CustomerLogin"}>Login</Link>
                    <span className="d-none d-md-inline">
                      {" "}
                      / <Link to={"/CustomerRegistration"}>Join</Link>
                    </span>
                  </span>
                </Button>
              )}

              <div
                onClick={() => setState({ isPaneOpen: true })}
                className="position-relative cart-icon-wrapper"
              >
                <ShoppingCart size={22} />
                <Badge bg="primary" className="cart-badge">
                  {cart.length || 0}
                </Badge>
              </div>
            </div>
          </Container>
        </Navbar>

        {/* Search Bar */}
        <div className="px-3 py-2 bg-white">
          <SearchBar />
        </div>
      </div>
    </>
  );
};

export default MobileHeader;
